import { createFileRoute, redirect } from "@tanstack/react-router";
import { getPaymentFromSessionStorage } from "@/features/payment/utils";
import {
  orderStatusQuery,
  resolvePaymentCompleteTarget,
} from "@/features/wash-start-guide/order-status";
import { getFeatureFlags } from "@/lib/runtime-config";

// Every payment path lands here once the payment went through, and is sent on
// to the wash start guide or today's invoice question.
export const Route = createFileRoute("/payment-complete")({
  loader: async ({ context }) => {
    const payment = getPaymentFromSessionStorage();
    if (!payment) {
      throw redirect({ to: "/start-screen", reloadDocument: true });
    }
    const washStartGuide = getFeatureFlags().washStartGuide;
    const status =
      washStartGuide && payment.orderId
        ? await context.queryClient
            .fetchQuery(orderStatusQuery(payment.orderId))
            .catch(() => null)
        : null;
    throw redirect({
      to: resolvePaymentCompleteTarget({ washStartGuide, status }),
    });
  },
});
